module.exports = require("lodash/capitalize");


//////////////////
// WEBPACK FOOTER
// external "lodash/capitalize"
// module id = 106
// module chunks = 0 1 2